import { Viewer } from "@react-pdf-viewer/core";
import { Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

function PdfModal({ open, handleClose, file }) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  if (!open) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000
    }}>
      <div style={{
        background: "#fff",
        width: "90%",
        height: "90%",
        borderRadius: "8px",
        overflow: "hidden",
        position: "relative"
      }}>
        <button 
          onClick={handleClose} 
          style={{
            position: "absolute", top: 10, right: 10,
            background: "red", color: "#fff", border: "none",
            padding: "8px 12px", borderRadius: "4px", cursor: "pointer",
            zIndex: 2000
          }}
        >
          Close
        </button>

        {file ? (
          <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
          <Viewer fileUrl={file} plugins={[defaultLayoutPluginInstance]} />
          </Worker>
        ) : (
          <p>No PDF selected</p>
        )}
      </div>
    </div>
  );
}

export default PdfModal;
